module.exports = __webpack_public_path__ + "img/Blank.3df2e20f.png";